export default "__VITE_ASSET__D3S_HwSN__"